export default __webpack_public_path__ + "static/media/building.0a7bee63.jpg";